import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useIframeCheck } from 'hooks/useIframeCheck';
import { useKiCodeAccess } from './useKiCodeAccess';
import {
  isKiCodeAvailable,
  selectAppEnabled,
  selectKiCodeIdentity,
  type KiCodeAuthentication,
} from './availability';

const selectRehydrating = (state: { authentication: KiCodeAuthentication }) =>
  state.authentication.rehydrating;
const selectAuthAppEnabled = (state: {
  authentication: KiCodeAuthentication;
}) => selectAppEnabled(state.authentication);
const selectIdentity = (state: { authentication: KiCodeAuthentication }) =>
  selectKiCodeIdentity(state.authentication);

export const useKiCodeAvailability = () => {
  const rehydrating = useSelector(selectRehydrating);
  const appEnabled = useSelector(selectAuthAppEnabled);
  const kiCodeAccess = useKiCodeAccess();
  const iframe = useIframeCheck();
  const { pathname } = useLocation();
  const identity = useSelector(selectIdentity);
  const available = isKiCodeAvailable({
    rehydrating,
    appEnabled,
    kiCodeAccess,
    iframe,
    pathname,
  });
  return { available, identity };
};
